window.slate = window.slate || {};
window.theme = window.theme || {};
window.woolman = window.woolman || {};

/*================ POLYFILLS ================*/
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }
    
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      //this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }

      
      $('#BIS_trigger').attr('data-variant-id',variant.id);
      if (variant.available === false){
        $('#BIS_trigger').removeClass('is-hidden');
      } else {
        $('#BIS_trigger').addClass('is-hidden');
      }
      
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Modules ================*/
theme.Slideshow = (function() {

	function Slideshow(container) {
		$(container).slick({
			arrows: false,
			dots: true
		});
	}

	return Slideshow;
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    imageSlider: '[data-product-image-slider]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    sizeAsButtonsSelect: '[data-size-as-buttons]',
    selectButtons: '[data-select-buttons]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  // Product image slider
  $(selectors.imageSlider).slick({
    lazyLoad: 'ondemand',
    autoplaySpeed: 10000,
    dots: true,
    autoplay: false,
    prevArrow: '<button type="button" class="slick-prev"><svg id="icon-arrow-left" xmlns="http://www.w3.org/2000/svg" width="9.18" height="14.12" viewBox="0 0 9.18 14.12"><title>icon-arrow-left</title><polygon points="7.06 14.12 0 7.06 7.06 0 9.18 2.12 4.24 7.06 9.18 12 7.06 14.12" fill="#333"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="9.18" height="14.12" viewBox="0 0 9.18 14.12"><title>icon-arrow-right</title><g id="icon-arrow-right"><polygon points="2.12 14.12 9.18 7.06 2.12 0 0 2.12 4.94 7.06 0 12 2.12 14.12" fill="#333"/></g></svg></button>'
  });

  // Product size select to buttons
    if ($(selectors.sizeAsButtonsSelect, this.$container).html()) {
      var $theSelect = $(selectors.sizeAsButtonsSelect, this.$container),
          $theButtons = $(selectors.selectButtons, this.$container);

      $theButtons.on('click', '.size-select', function() {
          $('.size-select').removeClass('selected');
          $(this).addClass('selected');
          $theSelect.val($(this).text()).trigger('change');
      });
    }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
	function SlideshowSection(container) {
		var $container = this.container = $(container);
		var sectionId = $container.attr('data-section-id');
		var slideshow = this.slideshow = '#slideshow-' + sectionId;

		theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
	}

	return SlideshowSection;
})();

// FOR THEME EDITOR
theme.SlideshowSection.prototype = $.extend({}, theme.SlideshowSection.prototype, {
	onUnload: function() {
		delete theme.slideshows[this.slideshow];
	},

	onBlockSelect: function(evt) {
		var $slideshow = $(this.slideshow);

		// Ignore cloned slides
		var $slide = $('.slide-' + evt.detail.blockId + ':not(.slick-cloned');
		var slideIndex = $slide.data('slick-index');

		// Go to selected slide
		$slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
	},

	onBlockDeselect: function() {
		// Resume autoplay
		$(this.slideshow).slick('slickPlay');
	}
});


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Woolman ================*/
//-----------------------------------------------------------//
// CACHED SELECTORS
woolman.cacheSelectors = function() {
  woolman.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Nav
    $header                 : $('[data-header]'),
    $topBar                 : $('[data-top-bar]'),
    $navButton              : $('[data-nav-button]'),
    $navigation             : $('[data-navigation]'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('[data-product-featured-image]'),
    $productThumbs           : $('[data-product-single-thumbnail]'),

    // Scroll To
    $scrollToButtons         : $('[data-scroll-to]'),

    // Product Size Selector
    $sizeSelectButtons       : $('[data-size-selector]'),
    $productCards            : $('[data-available-sizes]'),
  };
};


//-----------------------------------------------------------//
// PRODUCT PAGE IMAGES
woolman.productImageSwitch = function() {
  if (woolman.cache.$productThumbs.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    woolman.cache.$productThumbs.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      woolman.switchImage(newImage, null, woolman.cache.$productImage);
    });
  }
};

woolman.switchImage = function(src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};


//-----------------------------------------------------------//
// RESPONSIVE VIDEOS
woolman.responsiveVideos = function() {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function() {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="responsive-embed widescreen"></div>');
  });

  $iframeReset.each(function() {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

//-----------------------------------------------------------//
// ANIMATED SCROLL TO
woolman.scrollTo = function() {
  woolman.cache.$scrollToButtons.on('click', function() {
    var elementTo = '[' + $(this).data('scrollTo') + ']';

    $('html, body').animate({
        scrollTop: ($(elementTo).offset().top) - 120
    }, 600);
  });
};


//-----------------------------------------------------------//
// PRODUCT SIZE SELECTOR
woolman.sizeSelector = function() {

  var selectedSizes = [];
  woolman.cache.$sizeSelectButtons.find('button').each(function(index, element) {
    var element = $(element);
    if (element.hasClass('active')) { selectedSizes.push(Number(element.val())) };
  });


  var availableCards = [];
  var unavailableCards = [];
  if ( selectedSizes.length > 0 ) {
    woolman.cache.$productCards.each(function(index, element) {
      var card = $(this);
      var sizeData = JSON.parse('[' + card.data('available-sizes') + ']');
      var matchFound = false;
      for (var i = 0; i < selectedSizes.length; i++) {if ( selectedSizes[i] ) { if ( sizeData.includes(selectedSizes[i]) ) {matchFound = true}}};

      if (matchFound == true) {
        card.addClass('highlight');
        availableCards.push('<div class="cell">' + card.parent().html() + '</div>');
      } else {
        card.removeClass('highlight');
        unavailableCards.push('<div class="cell">' + card.parent().html() + '</div>');
      }
    });
    function onlyUnique(value, index, self) {return self.indexOf(value) === index};
    availableCards = availableCards.filter(onlyUnique).join('');
    unavailableCards = unavailableCards.filter(onlyUnique).join('');
    var new_html = availableCards + unavailableCards;
    $('.product-grid').fadeOut('fast').html(new_html).fadeIn('fast');
  };
};

// Cart variables and init
var $cartButtonCount, $cart, $cartItemsContainer, $totalPrice;

woolman.ajaxCartInit = function() {
  $cartButtonCount = $('[data-cart-count]'),
  $cart = $('[data-off-canvas-cart]'),
  $cartContent = $('[data-cart-content]'),
  $cartItemsContainer = $('#cartItems'),
  $totalPrice = $('#miniCartTotal');

  woolman.getAndBuildCart();
  woolman.cartItemQuantityClick();
};

woolman.cartItemQuantityClick = function() {
  $cart.on('click', '[data-update-quantity]', function() {

    var $clickedItem = $(this).closest('.quick-cart-item'),
        newCount = $clickedItem.data('item-count'),
        theVariantID = $clickedItem.data('product-id');

    if($(this).data('update-quantity') === 'increment') {
      newCount = newCount + 1;
    } else if ($(this).data('update-quantity') === 'decrement' ) {
      newCount = newCount - 1;
    };

    $('[data-update-quantity]').attr('disabled', 'disabled');
    $cart.addClass('loading');

    woolman.updateCartItem(theVariantID, newCount);
  });
};

woolman.getAndBuildCart = function() {
  $.getJSON('/cart.js', function (cart, textStatus) {
    woolman.buildCart(cart);
  });
};

woolman.addToCart = function(form) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: $(form).serialize(),
    dataType: 'json',
    beforeSend: function() {
      $(form).find('[type=submit]').attr('disabled', 'disabled').addClass('loading');
    },
    success: function(line_item) {
      $(form).find('.alertmsg').remove();
      woolman.getAndBuildCart();
      $('[data-off-canvas-cart]').foundation('open', 'addedToCart', form);
    },
    error: function(XMLHttpRequest, textStatus) {
      woolman.onError(XMLHttpRequest, textStatus, form);
    },
    complete: function(jqxhr, text) {
      $(form).find('[type=submit]').removeAttr('disabled').removeClass('loading');
    }
  };
  $.ajax(params);
};

woolman.deleteCartItem = function(line_item) {
  // TODO
};

woolman.updateCartItem = function(item_id, item_count) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'updates[+' + item_id + ' +]=' + item_count,
    dataType: 'json',
    success: function(cart) {
      woolman.buildCart(cart);
      $('[data-update-quantity]').removeAttr('disabled');
      $cart.removeClass('loading');
    }
  };

  $.ajax(params);
};

woolman.onError = function(XMLHttpRequest, textStatus, sourceForm) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    $(sourceForm).find('.alertmsg').remove();
    $(sourceForm).append( '<p class="alertmsg"><i class="fa fa-exclamation-triangle"></i>' + data.description + '</p>' );
  }
};

woolman.buildCart = function(cart) {
  // Show empty cart
  if (cart.item_count === 0) {
    $cartButtonCount.addClass('hide');
    $cartContent.html('<p class="cart-empty">' + "Your cart is currently empty." + '</p>');
    return;
  }

  $cartButtonCount.html(cart.item_count).removeClass('hide');

  // Handlebars.js cart layout
  var items = [],
      item = {},
      data = {},
      source = $("#ajax-cart-template").html(),
      template = Handlebars.compile(source);

  // Add each item to our handlebars.js data
  $.each(cart.items, function(index, cartItem) {

    if (cartItem.image != null){
      var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_100x100$1").replace('http:', '');
    } else {
      var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
    }

    // Create item's data object and add to 'items' array
    item = {
      variantId: cartItem.variant_id,
      url: cartItem.url,
      imgSrc: prodImg,
      count: cartItem.quantity,
      productTitle: cartItem.product_title,
      variantTitle: cartItem.variant_title,
      price: slate.Currency.formatMoney(cartItem.price, theme.moneyFormat)
    };

    items.push(item);
  });

  // Gather all cart data and add to DOM
  data = {
    items: items,
    note: cart.note,
    totalPrice: slate.Currency.formatMoney(cart.total_price, theme.moneyFormat),
    totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', slate.Currency.formatMoney(cart.total_discount, theme.moneyFormat)),
    totalCartDiscountApplied: cart.total_discount === 0 ? false : true
  }

  $cartContent.html(template(data));

  $(document.body).trigger('ajaxCartLoaded');
};

// woolman/quick-search.js
$(document).ready(function() {
  // CURRENCIES
  var bodyCurrencyData = $('body').data();

  Currency.format = bodyCurrencyData.currencyFormat;

  var shopCurrency = bodyCurrencyData.shopCurrency;

  /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
  Currency.moneyFormats[shopCurrency].money_with_currency_format = bodyCurrencyData.moneyWithCurrencyFormat;
  Currency.moneyFormats[shopCurrency].money_format = bodyCurrencyData.moneyFormat;
    
  /* Default currency */
  var defaultCurrency = bodyCurrencyData.defaultCurrency;
    
  /* Cookie currency */
  var cookieCurrency = Currency.cookie.read();

  /* Fix for customer account pages */
  $('span.money span.money').each(function() {
    $(this).parents('span.money').removeClass('money');
  });

  /* Saving the current price */
  $('span.money').each(function() {
    $(this).attr('data-currency-'+bodyCurrencyData.shopCurrency, $(this).html());
  });

  // If there's no cookie.
  if (cookieCurrency == null) {
    if (shopCurrency !== defaultCurrency) {
      Currency.convertAll(shopCurrency, defaultCurrency);
      $('body').removeClass('default-currency');
    }
    else {
      Currency.currentCurrency = defaultCurrency;
      $('body').addClass('default-currency');
    }
  }
  // If the cookie value does not correspond to any value in the currency dropdown.
  else if ($('[name="currencies"]').length && $('[name="currencies"] option[value="' + cookieCurrency + '"]').length === 0) {
    Currency.currentCurrency = shopCurrency;
    Currency.cookie.write(shopCurrency);
    $('body').addClass('default-currency');
  }
  else if (cookieCurrency === shopCurrency) {
    Currency.currentCurrency = shopCurrency;
    $('body').addClass('default-currency');
  }
  else {
    Currency.convertAll(shopCurrency, cookieCurrency);
    $('body').removeClass('default-currency');
  }

  // Currency selection
  $('[name="currencies"]').val(Currency.currentCurrency).change(function() {
    var newCurrency = $(this).val();
    $('[name="currencies"]').val(newCurrency);
    Currency.convertAll(Currency.currentCurrency, newCurrency);
    $('.selected-currency').text(Currency.currentCurrency);

    if (Currency.currentCurrency === shopCurrency) {
      $('body').addClass('default-currency');
    } else {
      $('body').removeClass('default-currency');
    }
  });

  var original_selectCallback = window.selectCallback;
  var selectCallback = function(variant, selector) {
    original_selectCallback(variant, selector);
    Currency.convertAll(shopCurrency, $('[name="currencies"]').val());
    $('.selected-currency').text(Currency.currentCurrency);
  };

  // For ajax cart
  $('body').on('ajaxCartLoaded', function(cart) {
    Currency.convertAll(shopCurrency, $('[name="currencies"]').val());
    $('.selected-currency').text(Currency.currentCurrency);  
  });

  $('.selected-currency').text(Currency.currentCurrency);
  
});

woolman.init = function() {
  woolman.cacheSelectors();
  woolman.responsiveVideos();
  woolman.scrollTo();

  woolman.productImageSwitch();
  woolman.ajaxCartInit();

  // SEARCH
  //woolman.quickSearchInit();
  //woolman.parseDefaultSearch();

  woolman.sizeSelector();
};

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('slideshow', theme.SlideshowSection);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // INIT Foundation.
  $(document).foundation();

  // INIT Woolman
  woolman.init();

  // ADD TO CART BUTTON
  $('form[action^="/cart/add"]').on('submit', function(evt) {
    evt.preventDefault();
    woolman.addToCart($(this));
  });

  $('[data-cart-button]').click(function(event) {
    event.preventDefault();
    $('[data-off-canvas-cart]').foundation('open');
  });

  // PRODUCT SLIDERS
  $('.product-slider').slick({
    mobileFirst: true,
    autoplay: false,
    speed: 600,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    prevArrow: '<button type="button" class="slick-prev"><svg id="icon-arrow-left" xmlns="http://www.w3.org/2000/svg" width="9.18" height="14.12" viewBox="0 0 9.18 14.12"><title>icon-arrow-left</title><polygon points="7.06 14.12 0 7.06 7.06 0 9.18 2.12 4.24 7.06 9.18 12 7.06 14.12" fill="#333"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="9.18" height="14.12" viewBox="0 0 9.18 14.12"><title>icon-arrow-right</title><g id="icon-arrow-right"><polygon points="2.12 14.12 9.18 7.06 2.12 0 0 2.12 4.94 7.06 0 12 2.12 14.12" fill="#333"/></g></svg></button>',
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          speed: 800,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          speed: 1000,
          centerMode: false,
        }
      }
    ]
  });

  // COLLECTION SORTING
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  $('[data-sort-by] a')
    .on('click', function() {
      Shopify.queryParams.sort_by = jQuery(this).data('value');
      location.search = jQuery.param(Shopify.queryParams);
    }
  );
});

/*
$(document).ready(function() {
  // INIT Foundation.
  $(document).foundation();

  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('navigation', theme.Navigation);
  sections.register('slideshow', theme.SlideshowSection);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Woolman - Initialize JS on docready
  woolman.init();

  // PRODUCT SLIDERS
  $('.product-slider').slick({
    mobileFirst: true,
    autoplay: false,
    speed: 600,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path fill="444" d="M3.45 10c0-.2.1-.3.21-.5L13.19.2a.82.82 0 0 1 .52-.2c.2 0 .3.1.51.2l1 1a.72.72 0 0 1 .21.5c0 .2-.21.3-.31.4L7.14 10l8.1 7.86a.72.72 0 0 1 .21.5c0 .2-.1.3-.21.5l-1 1a.79.79 0 0 1-.51.2c-.21 0-.31-.1-.52-.2L3.66 10.55A.82.82 0 0 1 3.45 10Z"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="icon"><path d="M15.89 10.5 6.36 19.8a.82.82 0 0 1-.52.2c-.2 0-.3-.1-.51-.2l-1-1a.72.72 0 0 1-.21-.5c0-.2.1-.3.21-.5l8.1-7.9-8-7.8a.78.78 0 0 1-.21-.4 1.78 1.78 0 0 1 .21-.5l1-1A.82.82 0 0 1 5.84 0a.82.82 0 0 1 .52.2l9.53 9.3a.72.72 0 0 1 .21.5A.54.54 0 0 1 15.89 10.5Z"/></svg></button>',
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          speed: 800,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          speed: 1000,
        }
      }
    ]
  });

  // ADD TO CART BUTTON
  $('form[action^="/cart/add"]').on('submit', function(evt) {
    evt.preventDefault();
    woolman.addToCart($(this));
  });

  $('[data-cart-link]').click(function(event) {
    event.preventDefault();
    $('[data-off-canvas-cart]').foundation('open');
  });

  // COLLECTION SORTING
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  $('[data-sort-by] a')
    .on('click', function() {
      Shopify.queryParams.sort_by = jQuery(this).data('value');
      location.search = jQuery.param(Shopify.queryParams);
    }
  );

});
*/
